import React, { useState, useEffect } from "react";
import "../../CommonCssFiles/planstyle.css";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Paper,
  Skeleton,
  createFilterOptions,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { Proposal, ProposerForm } from "../ProposalPage/Proposal";
import { findSelf, getDate } from "../../helper/common";
import Summary from "../../commonComponents/Summary";
import { payload } from "../../helper/godigit";
import { payload as carepayload } from "../../helper/carehealth";
import { payload as icicipayload } from "../../helper/icici";
import { payload as reliancepayload } from "../../helper/reliance";
import { payload as hdfcpayload } from "../../helper/hdfc";
import { companyId, sha512 } from "../../helper/common";
import axios from "axios";
import FormData from "form-data";
import Loader from "../../../AllPageComponents/Loader";
import "./Kycformdata.css";
import locations from "../../../locations.json";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import calculateAge from "../AfterPlanFetchPage/AgeModalHelper";
import FileBase64 from "react-file-base64";
import { uploadImageBase64 } from "../../Api/Api";
import bankNamesData from "../../../bankNames.json";

import {
  selectProposal,
  updateData,
  addInsuredData,
  updateInsuredData,
  selectHDFCcheckedQuestion,
  selectICICIcheckedQuestion,
  updatenamesekyc,
  selectReliancecheckedQuestion,
  updatePinKyc,
  addfield,
  settingGender,
  addkycfield,
  updateSateKyc,
} from "../../redux/Slice";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import Alert from "@mui/material/Alert";
import {
  afterPlanFetchApi,
  getReduxData,
  settingReduxData,
} from "../../Api/Api";
import Swal from "sweetalert2";
import Redirect from "../../../AllPageComponents/Rederict";
import { Button, Box, Typography, Chip } from "@mui/material";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { SelectChangeEvent } from "@mui/material/Select";
import { validate } from "uuid";

// import { isValid } from "react-datepicker/dist/date_utils";

const KYCfrom = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const history = useNavigate();

  const goBack = () => {
    history(-1);
  };

  const [apiResponse, setApiResponse] = useState();
  const [addonArr, setAddonArr] = useState();
  const [addonsArray, setAddonsArray] = useState();
  const [addonDataList, setAddonDataList] = useState();
  const [loader, setLoader] = useState(false);
  const [stopLoading, setStopLoading] = useState();

  const [kycData, setKycData] = useState();
  const [proposerData, setProposerData] = useState();

  const [pinCodeList, setPinCodeList] = useState([]);
  const [pinCodeListNom, setPinCodeListNom] = useState([]);

  const [firstNameErr, setFirstNameErr] = useState();
  const [middleNameErr, setMiddleNameErr] = useState();
  const [lastNameErr, setLastNameErr] = useState();
  const [kycAddressError, setKycAddressError] = useState();

  const [docTypeErr, setDocTypeErr] = useState();
  const [docTypeErrPan, setDocTypeErrPan] = useState();
  const [docTypeErrPanNum, setDocTypeErrPanNum] = useState();
  const [docTypeErrPanFile, setDocTypeErrPanFile] = useState();

  const [dobErr, setDobErr] = useState();
  const [docNumErr, setDocNumErr] = useState();
  const [nomNameErr, setNomNameErr] = useState();
  const [nomDobErr, setNomDobErr] = useState();
  const [nomRelErr, setNomRelErr] = useState();
  const [nomAddressError, setNomAddressError] = useState();
  const [nomPhoneError, setNomPhoneError] = useState();

  const [appointeeNameErr, setAppointeeNameErr] = useState();
  const [appointeeDobErr, setAppointeeDobErr] = useState();
  const [appointeeRelErr, setAppointeeRelErr] = useState();
  const [appointeeAddressError, setAppointeeAddressError] = useState();

  const [appointeeStateError, setApointeeStateError] = useState();
  const [appointeeCityError, setAppointeeCityError] = useState();

  const [nomStateError, setNomStateError] = useState();
  const [nomCityError, setNomCityError] = useState();

  const [showApointee, setShowApointee] = useState(false);

  const [emailError, setEmailError] = useState();
  const [pinError, setPinError] = useState();
  const [pinErrorApointee, setPinErrorApointee] = useState();
  const [pinErrorNom, setPinErrorNom] = useState();

  const [nameError, setNameError] = useState();
  const [accountError, setAccountError] = useState("");
  const [ifscError, setIfscError] = useState(""); // To store error messages
  const [bankNameError, setBankNameError] = useState(""); // To store error messages
  const [accountTypeErr, setAccountTypeErr] = useState("");

  const [branchError, setBranchError] = useState("");

  const [finalAddonList, setFinalAddonList] = useState();
  // State hooks for document and identity files
  const [selectedFile, setSelectedFile] = useState(null); // Document file (Front)
  const [selectedBackFile, setSelectedBackFile] = useState(null); // Document file (Back)
  const [selectedIdentityFile, setSelectedIdentityFile] = useState(null); // Identity Proof file (Front)
  const [selectedIdentityBackFile, setSelectedIdentityBackFile] =
    useState(null); // Identity Proof file (Back)
  const [fileError, setFileError] = useState("");
  const [identityFileError, setIdentityFileError] = useState("");

  const [identityFileErrorBack, setIdentityFileErrorBack] = useState("");
  const [fileErrorBack, setFileErrorBack] = useState("");

  const [selectedIDType, setSelectedIDType] = useState("");
  const [selectedDocumentDrop, setSelectedDocumentDrop] = useState("");

  const [idErrorSelect, setIdErrorSelect] = useState("");

  const [referralNo, setReferralNo] = useState();
  const [extData, setExtData] = useState();

  const [docFront, setDocFront] = useState("");
  const [docBack, setDocBack] = useState("");
  const [idFront, setIdFront] = useState("");
  const [idback, setIdBack] = useState("");
  const [kycpath, setKycPath] = useState({
    docfrontpath: "",
    docbackpath: "",
    idfrontpath: "",
    idbackpath: "",
    form60_path: "",
  });

  const [kycExtension, setKycExtension] = useState({
    docfrontext: "",
    docbackext: "",
    idfrontext: "",
    idbackext: "",
    form60_extension: "",
  });

  const [extraData, setExtraData] = useState();
  const [nomRelError, setNomRelError] = useState();
  const [referralNoError, setReferralNoError] = useState("");
  const [showForm, setShowForm] = useState(false);

  const [showForm16, setShowForm16] = useState(null);
  const [formUrl, setFormUrl] = useState("");
  const [form60Front, setForm60Front] = useState("");
  const [form60File, setForm60File] = useState("");

  const [addressPrfErr, setAddressPrfErr] = useState();

  const validateReferralNo = (value) => {
    const regex = /^G2P\d{4}$/;
    if (!regex.test(value)) {
      return "Referral No. must start with 'G2P' followed by 4 digits (e.g., G2P1234).";
    }
    return "";
  };

  const handleReferralChange = (e) => {
    const value = e.target.value.toUpperCase();
    setReferralNo(value);
    setReferralNoError(validateReferralNo(value)); // Validate input on change
  };

  const handleChange = (event) => {
    setSelectedIDType(event.target.value);
  };
  const handleChangeDrop = (event) => {
    setSelectedDocumentDrop(event.target.value);
  };

  const allowedFormats = [
    "application/pdf", // PDF
    "image/jpeg", // JPEG and JPG
    "image/jpg", // JPG (alternative)
    "image/png", // PNG
    "image/tiff", // TIFF
    "image/tif", // TIF (alternative)
  ];

  const maxFileSize = 5 * 1024 * 1024; // 5MB

  const fetchPlan = async () => {
    try {
      setLoader(true); // Start loading
      const response = await afterPlanFetchApi(unique_id, c_id, plan_id);

      if (response.data.response == null) {
        setStopLoading(true);
        handleError("Oops there is an error !");
      }

      setApiResponse(response.data);
      setAddonDataList(response.data.request.addonPrice);
      setFinalAddonList(response.data.request.addonPrice);

      if (response.data.request.addons) {
        let currentAddons = response.data.request.addons
          ? response.data.request.addons.split(",")
          : [];

        setAddonArr(currentAddons);
        setAddonsArray(currentAddons);
      }

      setLoader(false);
    } catch (error) {
      console.log("the error in afterfetchplan", error);
      setStopLoading(true);
      handleError("Oops there is an error !");
    } finally {
      setLoader(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchPlan();
  }, []);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const unique_id = params.get("req_id");
  const retry_kyc = params.get("retry_kyc");

  const errMsg = params.get("err_msg");

  const decodedError = errMsg ? decodeURIComponent(errMsg) : "";

  const plan_id = params.get("plan_id");
  const c_id = params.get("c_id");
  const urldata = params.get("url_data");
  const company = companyId();

  let pindodeList;
  let filterLocation;

  const handleError = (message) => {
    Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
    setStopLoading(true);
  };

  // Nomine relation for Relince

  const relincenomine = [
    { value: "Self", label: "Self" },
    { value: "Spouse", label: "Spouse" },
    { value: "Son", label: "Son" },
    { value: "Employee", label: "Employee" },
    { value: "Daughter", label: "Daughter" },
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
  ];

  const hdfcnomine = [
    // {
    //   value: "Brother",
    //   label: "Brother",
    // },

    {
      value: "Daughter",
      label: "Daughter",
    },

    {
      value: "Father",
      label: "Father",
    },

    {
      value: "Husband",
      label: "Husband",
    },
    {
      value: "Mother",
      label: "Mother",
    },

    // {
    //   value: "Sister",
    //   label: "Sister",
    // },

    {
      value: "Son",
      label: "Son",
    },

    {
      value: "Wife",
      label: "Wife",
    },
  ];

  const apointeeData = [
    {
      Key: "Brother",
      Data: "Brother",
    },
    {
      Key: "Daughter",
      Data: "Daughter",
    },
    {
      Key: "Father",
      Data: "Father",
    },
    {
      Key: "Father-in-law",
      Data: "Father-in-law",
    },
    {
      Key: "Husband",
      Data: "Husband",
    },
    {
      Key: "Mother",
      Data: "Mother",
    },
    {
      Key: "Mother-in-law",
      Data: "Mother-in-law",
    },
    {
      Key: "Sister",
      Data: "Sister",
    },
    {
      Key: "Son",
      Data: "Son",
    },
    {
      Key: "Wife",
      Data: "Wife",
    },
  ];

  // Nomine for others

  let bankNames = bankNamesData.sort((a, b) =>
    a.BankName.localeCompare(b.BankName)
  );

  const filterOptions = createFilterOptions({
    limit: 100, // Optional: limits number of options displayed
  });

  const OtherNominie = [
    { value: "0", label: "Select" },
    { value: "Mother", label: "Mother" },
    { value: "Father", label: "Father" },
    { value: "Grand Father", label: "Grand Father" },
    { value: "Grand Mother", label: "Grand Mother" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Self", label: "Self" },
    { value: "Husband", label: "Husband" },
    { value: "Wife", label: "Wife" },
    { value: "Father In Law", label: "Father In Law" },
    { value: "Mother In Law", label: "Mother In Law" },
    { value: "Uncle", label: "Uncle" },
    { value: "Aunt", label: "Aunt" },
    { value: "Grand Daughter", label: "Grand Daughter" },
    { value: "Grand Son", label: "Grand Son" },
    { value: "Son", label: "Son" },
    { value: "Daughter", label: "Daughter" },
  ];

  // kyc validation functions------------------
  const validateFirstName = (firstName) => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!firstName) {
      setFirstNameErr("First name is required.");
      return false;
    } else if (!nameRegex.test(firstName)) {
      setFirstNameErr("First name should only contain alphabets.");

      return false;
    } else {
      setFirstNameErr("");

      return true; // No error
    }
  };
  const validateMiddleName = (middleName) => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (middleName && !nameRegex.test(middleName)) {
      setMiddleNameErr("First name should only contain alphabets.");
      return false;
    } else {
      setMiddleNameErr("");
      return true; // No error
    }
  };

  const validateLastName = (firstName) => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!firstName) {
      setLastNameErr("Last name is required.");
      return false;
    } else if (!nameRegex.test(firstName)) {
      setLastNameErr("Last name should only contain alphabets.");

      return false;
    } else {
      setLastNameErr("");

      return true; // No error
    }
  };

  const validateDocType = (docType) => {
    if (docType != "D07" && docType) {
      setShowForm(true);
    } else {
      setShowForm(false);
    }

    if (!docType) {
      setDocTypeErr("Please select a document type.");
      return false;
    } else {
      setDocTypeErr("");

      return true; // No error
    }
  };

  const validateAccountType = (accountType) => {
    if (!accountType) {
      setAccountTypeErr("Please select an account type.");
      return false;
    } else {
      setAccountTypeErr("");

      return true; // No error
    }
  };

  const validatePanCheck = (docType) => {
    if (!docType) {
      setDocTypeErrPan("Please select an option");
      return false;
    } else {
      if (docType == "yes") {
        setShowForm16(false);
      } else if (docType == "no") {
        setShowForm16(true);
      }
      setDocTypeErrPan("");

      return true; // No error
    }
  };

  const validatePanCheckFile = (doc) => {
    if (!doc) {
      setDocTypeErrPanFile("Please upload your file");
      return false;
    } else {
      setDocTypeErrPanFile("");

      return true;
    }
  };

  const validatePanNumCheck = (docType) => {
    if (!docType) {
      setDocTypeErrPanNum("Please enter your pan number");
      return false;
    } else {
      setDocTypeErrPanNum("");

      return true; // No error
    }
  };

  const validateDob = (value) => {
    let ca = calculateAge(value);

    if (!value) {
      setDobErr("Date of birth cannot be blank");
      return false;
    }

    if (ca > 99) {
      setDobErr("Please select a valid date of birth (age must be at most 99)");
      return false;
    } else {
      setDobErr("");
      return true;
    }
  };

  const validateDobNom = (value) => {
    let ca = calculateAge(value);

    if (ca < 18) {
      setShowApointee(true);
    } else {
      setShowApointee(false);
    }

    if (!value) {
      setNomDobErr("Date of birth cannot be blank");
      return false;
    }

    if (ca > 99) {
      setNomDobErr(
        "Please select a valid date of birth (age must be at most 99)"
      );
      return false;
    } else {
      setNomDobErr("");
      return true;
    }
  };

  const validateDobNomPre = (value) => {
    // Check for empty, invalid, or NaN-like values
    if (
      !value ||
      value.includes("NaN") ||
      value === "undefined-NaN-undefined"
    ) {
      setNomDobErr("Invalid date. Please enter a valid DOB.");
      return false;
    }

    // Normalize and validate the date (handles missing leading zeros)
    const dateOfbirth = dayjs(
      value,
      ["YYYY-MM-DD", "YYYY-M-D", "DD-MM-YYYY"],
      true
    );

    if (dateOfbirth.isAfter(dayjs())) {
      setNomDobErr("Date of birth cannot be in the future.");
      return false;
    }

    setNomDobErr("");
    return true;
  };

  const validateDocNumber = (docNumber) => {
    const docNumberRegex = /^[A-Za-z0-9]+$/; // Allow only alphanumeric characters

    if (!docNumber) {
      setDocNumErr("Document number is required.");
      return false;
    } else if (!docNumberRegex.test(docNumber)) {
      setDocNumErr("Document number should only contain letters and numbers.");
      return false;
    } else if (docNumber.length < 5) {
      setDocNumErr("Document number must be at least 5 characters long.");
      return false;
    } else {
      setDocNumErr("");
      return true; // No error
    }
  };

  const validateFullName = (fullName) => {
    const nameRegex = /^[A-Za-z\s]+$/; // Allow only alphabets and spaces

    if (!fullName) {
      setNomNameErr("Full name is required.");
      return false;
    } else if (!nameRegex.test(fullName)) {
      setNomNameErr("Full name should only contain alphabets and spaces.");
      return false;
    } else if (fullName.trim().length < 3) {
      setNomNameErr("Full name must be at least 3 characters long.");
      return false;
    } else {
      setNomNameErr("");
      return true; // No error
    }
  };

  const validateApointeeFullName = (fullName) => {
    const nameRegex = /^[A-Za-z\s]+$/; // Allow only alphabets and spaces

    if (!fullName) {
      setAppointeeNameErr("Full name is required.");
      return false;
    } else if (!nameRegex.test(fullName)) {
      setAppointeeNameErr(
        "Full name should only contain alphabets and spaces."
      );
      return false;
    } else if (fullName.trim().length < 3) {
      setAppointeeNameErr("Full name must be at least 3 characters long.");
      return false;
    } else {
      setAppointeeNameErr("");
      return true; // No error
    }
  };

  const validateRelationship = (relationship) => {
    if (!relationship) {
      setNomRelErr("Relationship with proposer is required.");
      return false;
    } else {
      setNomRelErr("");
      return true; // No error
    }
  };

  const validateApointeeRelationship = (relationship) => {
    if (!relationship) {
      setAppointeeRelErr("Relationship with proposer is required.");
      return false;
    } else {
      setAppointeeRelErr("");
      return true; // No error
    }
  };

  const validateNomAddress = (address) => {
    if (!address) {
      setNomAddressError("Address is required.");
      return false;
    } else if (address.length < 5) {
      setNomAddressError("Address must be at least 5 characters long.");
      return false;
    } else {
      setNomAddressError("");
      return true; // No error
    }
  };

  const validateApointeeAddress = (address) => {
    if (!address) {
      setAppointeeAddressError("Address is required.");
      return false;
    } else if (address.length < 5) {
      setAppointeeAddressError("Address must be at least 5 characters long.");
      return false;
    } else {
      setAppointeeAddressError("");
      return true; // No error
    }
  };

  const validateApointeeState = (address) => {
    if (!address) {
      setApointeeStateError("State is required.");
      return false;
    } else {
      setApointeeStateError("");
      return true; // No error
    }
  };

  const validateApointeeCity = (address) => {
    if (!address) {
      setAppointeeCityError("City is required.");
      return false;
    } else {
      setAppointeeCityError("");
      return true; // No error
    }
  };

  const validateNomState = (address) => {
    if (!address) {
      setNomStateError("State is required.");
      return false;
    } else {
      setNomStateError("");
      return true; // No error
    }
  };

  const validateNomCity = (address) => {
    if (!address) {
      setNomCityError("City is required.");
      return false;
    } else {
      setNomCityError("");
      return true; // No error
    }
  };

  const validateEmail = (email) => {
    let newErrors = "";

    if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors = "Valid email is required";
    }
    setEmailError(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const validateStreet = (street) => {
    let isValid = true;
    if (!street || street.trim() == "") {
      setKycAddressError("Street address is required");
      isValid = false;
      return;
    }
    setKycAddressError("");
    return isValid;
  };

  const validateName = (name) => {
    if (!name?.trim()) {
      setNameError("Name is required");
      return false;
    }
    if (!/^[a-zA-Z\s]+$/.test(name)) {
      setNameError("Name can only contain letters and spaces");
      return false;
    }
    setNameError(""); // Clear error if valid
    return true;
  };

  const validateAccountNumber = (accountNumber) => {
    if (!accountNumber?.trim()) {
      setAccountError("Account Number is required");
      return false;
    }
    // Check if account number is numeric only, no spaces, and length is <= 21
    if (!/^\d{1,21}$/.test(accountNumber)) {
      setAccountError(
        "Account Number must be numeric and up to 21 digits, without spaces or special characters"
      );
      return false;
    }
    setAccountError(""); // Clear error if valid
    return true;
  };

  const validateBankName = (bankName) => {
    if (!bankName) {
      setBankNameError("Bank Name is required");
      return false;
    }
    setBankNameError(""); // Clear error if valid
    return true;
  };

  const validateIFSCCode = (ifscCode) => {
    // Regex to check alphanumeric only, up to 15 characters
    const ifscPattern = /^[A-Z0-9]{1,15}$/; // Alphanumeric, length up to 15

    if (!ifscCode?.trim()) {
      setIfscError("IFSC Code is required");
      return false;
    }
    if (ifscCode.length > 15) {
      setIfscError("IFSC Code must be a maximum of 15 characters long");
      return false;
    }
    if (!ifscPattern.test(ifscCode)) {
      setIfscError(
        "IFSC Code must be alphanumeric, with no spaces or special characters"
      );
      return false;
    }

    setIfscError("");
    return true;
  };

  const validateBranchName = (branch) => {
    if (!branch?.trim()) {
      setBranchError("Branch Name is required");
      return false;
    }

    setBranchError("");
    return true;
  };

  const isValidIndianPhoneNumber = (phoneNumber) => {
    const indianPhoneNumberRegex = /^[6-9]\d{9}$/;
    return indianPhoneNumberRegex.test(phoneNumber);
  };
  const validateNomPhoneNumber = (phoneNumber) => {
    let isValid = true;
    if (phoneNumber === "") {
      setNomPhoneError("Phone number is required");
      isValid = false;
    } else if (!isValidIndianPhoneNumber(phoneNumber)) {
      setNomPhoneError("Please enter a valid Indian phone number");
      isValid = false;
    } else if (phoneNumber.length !== 10) {
      setNomPhoneError("Phone number must be 10 digits");
      isValid = false;
    } else {
      setNomPhoneError("");
    }
    return isValid;
  };

  const validatePinCode = (selectedPinCode, pinCodeList) => {
    let isValid;
    if (!selectedPinCode) {
      isValid = false;
      setPinError("pincode is required");
      return false;
    } else {
      isValid = true;
      setPinError("");
      return true;
    }
  };

  const validatePinCodeApointee = (selectedPinCode, pinCodeList) => {
    let isValid;
    if (!selectedPinCode) {
      isValid = false;
      setPinErrorApointee("pincode is required");
      return false;
    } else {
      isValid = true;
      setPinErrorApointee("");
      return true;
    }
  };

  const validatePinCodeNom = (selectedPinCode, pinCodeList) => {
    let isValid;
    if (!selectedPinCode) {
      isValid = false;
      setPinErrorNom("pincode is required");
      return false;
    } else {
      isValid = true;
      setPinErrorNom("");
      return true;
    }
  };

  const validateAddressProof = (data) => {
    if (!data) {
      setAddressPrfErr("Plese select any option");
      return false;
    } else {
      setAddressPrfErr("");
      return true;
    }
  };

  const validateIdProof = (data) => {
    if (!data) {
      setIdErrorSelect("Plese select any option");
      return false;
    } else {
      setIdErrorSelect("");
      return true;
    }
  };

  const validateAddFront = (data) => {
    if (!data) {
      setFileError("Please upload valid document");
      return false;
    } else {
      setFileError("");
      return true;
    }
  };

  const validateIdBack = (data) => {
    if (!data) {
      setIdentityFileErrorBack("Please upload valid document");
      return false;
    } else {
      setIdentityFileErrorBack("");
      return true;
    }
  };

  const validateIdFront = (data) => {
    if (!data) {
      setIdentityFileError("Please upload valid document");
      return false;
    } else {
      setIdentityFileError("");
      return true;
    }
  };

  const validateAddPhoto = (data) => {
    if (!data) {
      setFileErrorBack("Please upload valid photo");
      return false;
    } else {
      setFileErrorBack("");
      return true;
    }
  };

  // full kyc form validation
  const validateKycForm = () => {
    let phoneNumberValid;
    let nameValid;
    let bankNameValid;
    let accountNumberValid;
    let ifscCodeValid;
    let relationwithNominee;

    let nomineerelationshipValid = validateRelationship(
      kycData.nomineerelationship
    );

    let nomineeNameValid = validateFullName(kycData.nomineeName);
    let nomineedateOfbirthValid = validateDobNom(kycData.nomineedateOfbirth);
    let nomineeAddressValid = validateNomAddress(kycData.nomineeAddress);

    let firstnameValid = validateFirstName(kycData.firstname);
    // let middlenameValid = validateMiddleName(kycData.middlename);
    let lastnameValid = validateLastName(kycData.lastname);
    let NameValid = validateFullName(kycData.nomineeName);
    let KycdateOfbirthValid = validateDob(kycData.KycdateOfbirth);
    let kycIdValid = validateDocType(kycData.kycId);
    let cardNumValid = validateDocNumber(kycData.cardNum);

    let apointeeNameValid;
    let apointeeRelationValid;
    let apointeeAddressValid;
    let apointeeStateValid;
    let apointeePinValid;
    let apointeeCityValid;

    let nomStateValid;
    let nomPinValid;
    let nomCityValid;

    let idtype;

    // for star -----------

    let availablePan;
    let availableform60;
    let avlaltpan;
    let addProofType;
    let docFront;
    let docPhoto;

    let idProofType;
    let idDocFront;
    let idDocBack;

    let branchName;
    let accountType;

    if (["care", "hdfc", "star"].includes(c_id)) {
      nameValid = validateName(kycData.Name);
      bankNameValid = validateBankName(kycData.bankName);
      accountNumberValid = validateAccountNumber(kycData.accountNumber);
      ifscCodeValid = validateIFSCCode(kycData.ifscCode);
    }

    if (c_id == "star") {
      availablePan = validatePanCheck(kycData.kycPan);

      availableform60 = validatePanCheckFile(form60Front);
      avlaltpan = validatePanNumCheck(kycData.kycPanNum);
      addProofType = validateAddressProof(kycData.kycaddressproof);
      docFront = validateAddFront(selectedFile);
      docPhoto = validateAddPhoto(selectedBackFile);

      if (plan_id === "SUPERSTARIND") {
        branchName = validateBranchName(kycData.branchName);
        accountType = validateAccountType(kycData.accountType);
      }
    }

    if (c_id === "icici" && plan_id === "unknown") {
      addProofType = validateAddressProof(kycData.kycaddressproof);
      docFront = validateAddFront(selectedFile);
      // docPhoto = validateAddPhoto(selectedBackFile);

      idProofType = validateIdProof(kycData.kycidproof);
      idDocFront = validateIdFront(selectedIdentityFile);
      // idDocBack = validateIdBack(selectedIdentityBackFile);
    }

    if (c_id == "hdfc") {
      relationwithNominee = validateNomineeRelation(
        kycData.RelationWithNominee
      );
      if (showApointee) {
        apointeeNameValid = validateApointeeFullName(kycData.apointeeName);
        apointeeRelationValid = validateApointeeRelationship(
          kycData.apointeerelationship
        );
        apointeeAddressValid = validateApointeeAddress(kycData.apointeeAddress);
        apointeeStateValid = validateApointeeState(kycData.apointeeState);
        apointeePinValid = validatePinCodeApointee(kycData.PinCodeApointee);
        apointeeCityValid = validateApointeeCity(kycData.apointeeCity);

        nomStateValid = validateNomState(kycData.nomState);
        nomPinValid = validatePinCodeNom(kycData.PinCodeNom);
        nomCityValid = validateNomCity(kycData.nomCity);
      }
    }

    if (c_id == "reliance") {
      phoneNumberValid = validateNomPhoneNumber(kycData.nomineePhoneNumber);
    }

    let EmailValid = validateEmail(kycData.Email);
    let streetValid = validateStreet(kycData.street);
    let PinCodeValid = validatePinCode(kycData.PinCode);

    let allRight;

    if (c_id == "reliance") {
      allRight =
        nomineerelationshipValid &&
        nomineeNameValid &&
        nomineedateOfbirthValid &&
        nomineeAddressValid &&
        firstnameValid &&
        lastnameValid &&
        NameValid &&
        KycdateOfbirthValid &&
        kycIdValid &&
        cardNumValid &&
        EmailValid &&
        streetValid &&
        PinCodeValid &&
        phoneNumberValid;
    } else if (["care", "hdfc"].includes(c_id)) {
      if (c_id == "hdfc") {
        if (showApointee) {
          allRight =
            nomineerelationshipValid &&
            nomineeNameValid &&
            nomineedateOfbirthValid &&
            nomineeAddressValid &&
            relationwithNominee &&
            firstnameValid &&
            lastnameValid &&
            NameValid &&
            KycdateOfbirthValid &&
            kycIdValid &&
            cardNumValid &&
            nameValid &&
            bankNameValid &&
            accountNumberValid &&
            ifscCodeValid &&
            EmailValid &&
            streetValid &&
            PinCodeValid &&
            apointeeNameValid &&
            apointeeRelationValid &&
            apointeeAddressValid &&
            apointeeStateValid &&
            apointeeCityValid &&
            apointeePinValid &&
            nomStateValid &&
            nomPinValid &&
            nomCityValid;
        } else {
          allRight =
            nomineerelationshipValid &&
            nomineeNameValid &&
            nomineedateOfbirthValid &&
            nomineeAddressValid &&
            relationwithNominee &&
            firstnameValid &&
            lastnameValid &&
            NameValid &&
            KycdateOfbirthValid &&
            kycIdValid &&
            cardNumValid &&
            nameValid &&
            bankNameValid &&
            accountNumberValid &&
            ifscCodeValid &&
            EmailValid &&
            streetValid &&
            PinCodeValid;
        }
      } else {
        allRight =
          nomineerelationshipValid &&
          nomineeNameValid &&
          nomineedateOfbirthValid &&
          nomineeAddressValid &&
          firstnameValid &&
          lastnameValid &&
          NameValid &&
          KycdateOfbirthValid &&
          kycIdValid &&
          cardNumValid &&
          nameValid &&
          bankNameValid &&
          accountNumberValid &&
          ifscCodeValid &&
          EmailValid &&
          streetValid &&
          PinCodeValid;
      }
    } else if (c_id == "star") {
      if (kycData.kycId && kycData.kycId != "D07") {
        if (kycData.kycPan == "yes") {
          if (plan_id == "SUPERSTARIND") {
            allRight =
              nomineerelationshipValid &&
              nomineeNameValid &&
              nomineedateOfbirthValid &&
              nomineeAddressValid &&
              firstnameValid &&
              lastnameValid &&
              NameValid &&
              KycdateOfbirthValid &&
              kycIdValid &&
              cardNumValid &&
              EmailValid &&
              streetValid &&
              PinCodeValid &&
              addProofType &&
              docFront &&
              docPhoto &&
              availablePan &&
              avlaltpan &&
              nameValid &&
              bankNameValid &&
              accountNumberValid &&
              ifscCodeValid &&
              accountType &&
              branchName;
          } else {
            allRight =
              nomineerelationshipValid &&
              nomineeNameValid &&
              nomineedateOfbirthValid &&
              nomineeAddressValid &&
              firstnameValid &&
              lastnameValid &&
              NameValid &&
              KycdateOfbirthValid &&
              kycIdValid &&
              cardNumValid &&
              EmailValid &&
              streetValid &&
              PinCodeValid &&
              addProofType &&
              docFront &&
              docPhoto &&
              availablePan &&
              avlaltpan;
          }
        } else if (kycData.kycPan == "no") {
          if (plan_id == "SUPERSTARIND") {
            allRight =
              nomineerelationshipValid &&
              nomineeNameValid &&
              nomineedateOfbirthValid &&
              nomineeAddressValid &&
              firstnameValid &&
              lastnameValid &&
              NameValid &&
              KycdateOfbirthValid &&
              kycIdValid &&
              cardNumValid &&
              EmailValid &&
              streetValid &&
              PinCodeValid &&
              addProofType &&
              docFront &&
              docPhoto &&
              availablePan &&
              availableform60 &&
              nameValid &&
              bankNameValid &&
              accountNumberValid &&
              ifscCodeValid &&
              accountType &&
              branchName;
          } else {
            allRight =
              nomineerelationshipValid &&
              nomineeNameValid &&
              nomineedateOfbirthValid &&
              nomineeAddressValid &&
              firstnameValid &&
              lastnameValid &&
              NameValid &&
              KycdateOfbirthValid &&
              kycIdValid &&
              cardNumValid &&
              EmailValid &&
              streetValid &&
              PinCodeValid &&
              addProofType &&
              docFront &&
              docPhoto &&
              availablePan &&
              availableform60;
          }
        }
      } else {
        if (plan_id == "SUPERSTARIND") {
          allRight =
            nomineerelationshipValid &&
            nomineeNameValid &&
            nomineedateOfbirthValid &&
            nomineeAddressValid &&
            firstnameValid &&
            lastnameValid &&
            NameValid &&
            KycdateOfbirthValid &&
            kycIdValid &&
            cardNumValid &&
            EmailValid &&
            streetValid &&
            PinCodeValid &&
            addProofType &&
            docFront &&
            docPhoto &&
            nameValid &&
            bankNameValid &&
            accountNumberValid &&
            ifscCodeValid &&
            accountType &&
            branchName;
        } else {
          allRight =
            nomineerelationshipValid &&
            nomineeNameValid &&
            nomineedateOfbirthValid &&
            nomineeAddressValid &&
            firstnameValid &&
            lastnameValid &&
            NameValid &&
            KycdateOfbirthValid &&
            kycIdValid &&
            cardNumValid &&
            EmailValid &&
            streetValid &&
            PinCodeValid &&
            addProofType &&
            docFront &&
            docPhoto;
        }
      }
    } else if (c_id == "icici" && plan_id == "unknown") {
      allRight =
        nomineerelationshipValid &&
        nomineeNameValid &&
        nomineedateOfbirthValid &&
        nomineeAddressValid &&
        firstnameValid &&
        lastnameValid &&
        NameValid &&
        KycdateOfbirthValid &&
        kycIdValid &&
        cardNumValid &&
        EmailValid &&
        streetValid &&
        PinCodeValid &&
        addProofType &&
        docFront &&
        idDocFront;
    } else {
      allRight =
        nomineerelationshipValid &&
        nomineeNameValid &&
        nomineedateOfbirthValid &&
        nomineeAddressValid &&
        firstnameValid &&
        lastnameValid &&
        NameValid &&
        KycdateOfbirthValid &&
        kycIdValid &&
        cardNumValid &&
        EmailValid &&
        streetValid &&
        PinCodeValid;
    }

    return allRight;
  };

  // Kyc Doc Array

  const kycOptions = [
    { value: "D07", label: "PAN" },
    { value: "D02", label: "CKYC" },
    { value: "D03", label: "AADHAAR" },
    { value: "D04", label: "DL" },
    { value: "D05", label: "VOTERID" },
    { value: "D06", label: "PASSPORT" },
    { value: "D030", label: "CIN" },
  ];

  const accountType = [
    { value: "CA", label: "Current Account" },
    { value: "SA", label: "Savings Account" },
    { value: "O", label: "Other Account" },
  ];

  const panOptions = [
    { value: "yes", label: "YES" },
    { value: "no", label: "NO" },
  ];

  const HdfcrelationshipOptions = [
    {
      value: "Brother",
      label: "Brother",
    },
    {
      value: "Daughter",
      label: "Daughter",
    },
    {
      value: "Father",
      label: "Father",
    },
    {
      value: "Father-in-law",
      label: "Father-in-law",
    },
    {
      value: "Husband",
      label: "Husband",
    },
    {
      value: "Mother",
      label: "Mother",
    },
    {
      value: "Mother-in-law",
      label: "Mother-in-law",
    },
    {
      value: "Sister",
      label: "Sister",
    },
    {
      value: "Son",
      label: "Son",
    },
    {
      value: "Wife",
      label: "Wife",
    },
  ];

  const defaultIdentityOptions = [
    { value: "VOTERID", label: "Voter ID" },
    { value: "DL", label: "Driving License" },
    { value: "PASSPORT", label: "Passport" },
    { value: "PAN", label: "Pan" },
    { value: "OTHER", label: "Other" },
  ];

  const icici_proofOfIdentity = [
    { value: "AADHAAR", label: "AADHAAR" },
    { value: "PAN", label: "PAN" },
    { value: "VOTERID", label: "VOTERID" },
    { value: "PASSPORT", label: "PASSPORT" },
    { value: "DL", label: "DL" },
  ];

  const identityOptions =
    c_id == "icici" && plan_id == "unknown"
      ? icici_proofOfIdentity
      : defaultIdentityOptions;

  const icici_proofOfAddress = [
    { value: "AADHAAR", label: "AADHAAR" },
    { value: "VOTER", label: "VOTER" },
    { value: "PASSPORT", label: "PASSPORT" },
    { value: "DL", label: "DL" },
  ];

  const defaultAddressOptions = [
    { value: "VOTERID", label: "Voter ID" },
    { value: "DL", label: "Driving License" },
    { value: "PASSPORT", label: "Passport" },
    { value: "AADHAAR", label: "Aadhaar" },
    { value: "OTHER", label: "Other" },
  ];

  const addressOptions =
    c_id === "icici" && plan_id === "unknown"
      ? icici_proofOfAddress
      : defaultAddressOptions;

  const getData = async () => {
    try {
      let proposalData;
      let response = await getReduxData(unique_id).then((response) => {
        if (response?.data?.data[0]?.proposal_data) {
          setProposerData(response.data.data[0].proposal_data);
          proposalData = response?.data?.data[0]?.proposal_data;
        }

        if (response?.data?.data[0]?.kyc_data) {
          setKycData(response.data.data[0].kyc_data);
        }

        if (
          response?.data?.data[0]?.kyc_data?.kycId != "D07" &&
          response?.data?.data[0]?.kyc_data?.kycId
        ) {
          setShowForm(true);
        }

        if (response?.data?.data[0]?.kyc_data?.kycPan) {
          if (response?.data?.data[0]?.kyc_data?.kycPan == "yes") {
            setShowForm16(false);
          } else if (response?.data?.data[0]?.kyc_data?.kycPan == "no") {
            setShowForm16(true);
          }
        }
        if (response?.data?.data[0]?.extra_data) {
          setExtraData(response.data.data[0].extra_data);
          setReferralNo(response.data.data[0].extra_data?.referralNo);
        }

        if (response?.data?.data[0]?.extra_data) {
          setExtData(response.data.data[0].extra_data);
        }
        // addressDocType: selectedDocumentDrop,
        // identityDocType:selectedIDType,
        if (response?.data?.data[0]?.kyc_data?.addressDocType) {
          setSelectedDocumentDrop(
            response?.data?.data[0]?.kyc_data?.addressDocType
          );
        }
        if (response?.data?.data[0]?.kyc_data?.identityDocType) {
          setSelectedIDType(response?.data?.data[0]?.kyc_data?.identityDocType);
        }

        if (
          response.data.data[0].kyc_data?.nomineedateOfbirth &&
          c_id == "hdfc"
        ) {
          let age = calculateAge(
            response.data.data[0].kyc_data?.nomineedateOfbirth
          );

          if (age < 18) {
            setShowApointee(true);
          } else {
            setShowApointee(false);
          }
        }

        if (Object.keys(response?.data?.data[0]?.kyc_data).length == 0) {
          // setKycData((prevData)=>(
          //   {
          //     ...prevData,
          //     firstname : response.data.data[0].proposal_data?.ProposalName?.split(" ")[0],
          //     lastname : response.data.data[0].proposal_data?.ProposalName?.split(" ")
          //     .slice(1)
          //     .join(" "),
          //     KycdateOfbirth:(response.data.data[0].proposal_data?.dateOfbirth &&
          //       dayjs(response.data.data[0].proposal_data?.dateOfbirth)) ,
          //       PinCode : response.data.data[0].proposal_data?.PinCode

          //   }
          // )

          // )

          setKycData((prevData) => ({
            ...prevData,
            firstname:
              response.data.data[0].proposal_data?.ProposalName?.split(" ")[0],
            lastname: response.data.data[0].proposal_data?.ProposalName?.split(
              " "
            )
              .slice(-1) // The last part will always be the lastname
              .join(" "),
            middlename:
              response.data.data[0].proposal_data?.ProposalName?.split(" ")
                .slice(1, -1)
                .join(" ") || null, // Middlename is everything between the first and last name
            KycdateOfbirth: response.data.data[0].proposal_data?.dateOfbirth,
            PinCode: response.data.data[0].proposal_data?.PinCode,
          }));
        }

        if (response?.data?.data[0]?.kyc_data?.kyc_photo) {
          let data = response?.data?.data[0]?.kyc_data?.kyc_photo;
          setSelectedFile(data?.docfront ? data.docfront : "");
          setSelectedBackFile(data?.docback ? data?.docback : "");
          setSelectedIdentityFile(data?.idfront ? data?.idfront : "");
          setSelectedIdentityBackFile(data?.idback ? data?.idback : "");
        }

        if (response?.data?.data[0]?.kyc_data?.kyc_photo_path) {
          let data = response?.data?.data[0]?.kyc_data?.kyc_photo_path;
          setKycPath(data);
        }
        if (response?.data?.data[0]?.kyc_data?.kyc_photo_path?.form60path) {
          let fileName =
            (response?.data?.data[0]?.kyc_data?.kyc_photo_path?.form60path).split(
              "kyc_doc/"
            )[1];
          // let fullFormUrl = `${process.env.REACT_APP_SOCKET_URL}${fileName}`;
          setForm60Front(fileName);
        }
        if (response?.data?.data[0]?.kyc_data?.kyc_extension) {
          let data = response?.data?.data[0]?.kyc_data?.kyc_extension;
          setKycExtension(data);
        }

        if (proposalData && proposalData.InsuredDetail.length != 0) {
          filterLocation = locations.filter(
            (element) =>
              element.District.toLowerCase() ==
              proposalData.District.toLowerCase()
          );

          const pinCodeListNom = locations.map((item) => ({
            label: String(item.Pincode), // Must be string for Autocomplete
            District: item.District,
            StateName: item.StateName,
          }));

          setPinCodeListNom(pinCodeListNom);

          for (let i = 0; i < filterLocation.length; i++) {
            pinCodeList.push({
              label: filterLocation[i].Pincode,
              state: filterLocation[i].StateName,
            });
          }
        }
      });
    } catch (error) {
      console.log("the error", error);
    }
  };

  // const fileuploadData = async (docdata, ext) => {
  //   try {
  //     let payloaddata = {
  //       doc_data: docdata,
  //       extension: ext,
  //     };

  //     let response = await uploadImageBase64(
  //       payloaddata,
  //       c_id,
  //       plan_id,
  //       unique_id
  //     );

  //     return response;
  //   } catch (error) {
  //     console.log("the error in file upload", error);
  //   }
  // };

  const fileuploadData = async (docdata, ext) => {
    try {
      let payloaddata = {
        doc_data: docdata,
        extension: ext,
      };

      let response = await uploadImageBase64(
        payloaddata,
        c_id,
        plan_id,
        unique_id
      );

      return response;
    } catch (error) {
      console.log("the error in file upload", error);
    }
  };

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];

    const handleError = (errorType, message) => {
      if (errorType === "document") {
        setFileError(message);
        setSelectedFile(null);
      } else if (errorType === "identity") {
        setIdentityFileError(message);
        setSelectedIdentityFile(null);
      } else if (errorType === "documentBack") {
        setFileErrorBack(message);
        setSelectedBackFile(null);
      } else if (errorType === "identityBack") {
        setIdentityFileErrorBack(message);
        setSelectedIdentityBackFile(null);
      } else if (errorType === "form60") {
        setDocTypeErrPanFile(message);
        setFormUrl(null);
      }
    };

    if (file) {
      if (!allowedFormats.includes(file.type)) {
        handleError(
          type,
          "Invalid file format. Please upload PDF, JPEG, JPG, PNG, or TIFF."
        );
        return;
      }

      if (file.size > maxFileSize) {
        handleError(
          type,
          "File size exceeds 5MB. Please upload a smaller file."
        );
        return;
      }

      if (type === "document") {
        setFileError("");
        handleFileUpload("document", file);
      } else if (type === "identity") {
        setIdentityFileError("");
        handleFileUpload("identity", file);
      } else if (type === "documentBack") {
        setIdentityFileErrorBack("");
        handleFileUpload("documentBack", file);
      } else if (type === "identityBack") {
        setIdentityFileErrorBack("");
        handleFileUpload("identityBack", file);
      } else if (type === "form60") {
        setDocTypeErrPanFile("");
        handleFileUpload("form60", file);
      }
    } else {
      handleError(type, "No file selected. Please choose a file.");
    }
  };

  const handleFileUpload = async (filename, file) => {
    try {
      const base64String = await convertImageToBase64(file);

      let extension = file.name.split(".");
      extension = extension[extension.length - 1].toLowerCase();

      if (base64String) {
        let pathdata = await fileuploadData(base64String, extension);
        let imgdata = `${process.env.REACT_APP_SOCKET_URL}${pathdata.data.file_path}`;

        if (filename == "document") {
          setSelectedFile(imgdata);
          setDocFront(file.name);
          setKycPath((prevState) => ({
            ...prevState,
            docfrontpath: pathdata?.data?.file_path,
          }));
          setKycExtension((prevState) => ({
            ...prevState,
            docfrontext: extension,
          }));
        } else if (filename == "identity") {
          setSelectedIdentityFile(imgdata);
          setIdFront(file.name);
          setKycPath((prevState) => ({
            ...prevState,
            idfrontpath: pathdata?.data?.file_path,
          }));
          setKycExtension((prevState) => ({
            ...prevState,
            idfrontext: extension,
          }));
        } else if (filename == "documentBack") {
          setSelectedBackFile(imgdata);
          setDocBack(file.name);
          setKycPath((prevState) => ({
            ...prevState,
            docbackpath: pathdata?.data?.file_path,
          }));
          setKycExtension((prevState) => ({
            ...prevState,
            docbackext: extension,
          }));
        } else if (filename == "identityBack") {
          setSelectedIdentityBackFile(imgdata);
          setIdBack(file.name);
          setKycPath((prevState) => ({
            ...prevState,
            idbackpath: pathdata?.data?.file_path,
          }));
          setKycExtension((prevState) => ({
            ...prevState,
            idbackext: extension,
          }));
        } else if (filename == "form60") {
          // setFormUrl(file.name);
          // setKycPath((prevState) => ({
          //   ...prevState,
          //   formpath: pathdata?.data?.file_path,
          // }));
          // setKycExtension((prevState) => ({
          //   ...prevState,
          //   formext: extension,
          // }));

          setForm60File(imgdata);
          setForm60Front(file.name);
          setKycPath((prevState) => ({
            ...prevState,
            form60path: pathdata?.data?.file_path,
          }));
          setKycExtension((prevState) => ({
            ...prevState,
            form60ext: extension,
          }));
        }

        return base64String.toString();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const handleFileChange = (event, type) => {
  //   const file = event.target.files[0];

  //   const handleError = (errorType, message) => {
  //     if (errorType === "document") {
  //       setFileError(message);
  //       setSelectedFile(null);
  //     } else if (errorType === "identity") {
  //       setIdentityFileError(message);
  //       setSelectedIdentityFile(null);
  //     } else if (errorType === "documentBack") {
  //       setFileErrorBack(message);
  //       setSelectedBackFile(null);
  //     } else if (errorType === "identityBack") {
  //       setIdentityFileErrorBack(message);
  //       setSelectedIdentityBackFile(null);
  //     } else if (errorType === "form60") {
  //       setDocTypeErrPanFile(message);
  //       setFormUrl(null);
  //     }
  //   };

  //   if (file) {
  //     if (!allowedFormats.includes(file.type)) {
  //       handleError(
  //         type,
  //         "Invalid file format. Please upload PDF, JPEG, JPG, PNG, or TIFF only."
  //       );
  //       return;
  //     }

  //     if (file.size > maxFileSize) {
  //       handleError(
  //         type,
  //         "File size exceeds 5MB. Please upload a smaller file."
  //       );
  //       return;
  //     }

  //     if (type === "document") {
  //       setFileError("");
  //       handleFileUpload("document", file);
  //     } else if (type === "identity") {
  //       setIdentityFileError("");
  //       handleFileUpload("identity", file);
  //     } else if (type === "documentBack") {
  //       setFileErrorBack("");
  //       handleFileUpload("documentBack", file);
  //     } else if (type === "identityBack") {
  //       setIdentityFileErrorBack("");
  //       handleFileUpload("identityBack", file);
  //     } else if (type === "form60") {
  //       setDocTypeErrPanFile("");
  //       handleFileUpload("form60", file);
  //     }
  //   } else {
  //     handleError(type, "No file selected. Please choose a file.");
  //   }
  // };

  const renderImagePreview = (file) => {
    if (file) {
      const isUrl =
        typeof file == "string" &&
        (file.startsWith("http://") || file.startsWith("https://"));

      const imageSrc = isUrl ? file : URL.createObjectURL(file);

      return (
        <img
          src={imageSrc}
          alt="Preview"
          style={{
            marginTop: "10px",
            width: "83%",
            height: "140px",
            objectFit: "contain",
            borderRadius: "8px",
            objectPosition: "center",
          }}
        />
      );
    }
    return null;
  };

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  // const convertImageToBase64 = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => {
  //       const base64String = reader.result.split(",")[1];
  //       resolve(base64String);
  //     };
  //     reader.onerror = (error) => {
  //       reject("Error converting file: " + error);
  //     };
  //   });
  // };

  const validateNomineeRelation = (value) => {
    if (!value) {
      setNomRelError("Please select a relationship with the nominee.");
      return false;
    }
    setNomRelError("");
    return true;
  };

  const settingData = async () => {
    try {
      let phNo = proposerData.Proposalphonenumber;

      let extraobj = {
        ...extraData,
        referralNo: referralNo,
      };

      let kycphoto = {
        docfront: selectedFile,
        docback: selectedBackFile,
        idfront: selectedIdentityFile,
        idback: selectedIdentityBackFile,
      };

      let kycobj = {
        ...kycData,
        addressDocType: selectedDocumentDrop,
        identityDocType: selectedIDType,
        kyc_photo: kycphoto,
        kyc_photo_path: kycpath,
        kyc_extension: kycExtension,
      };

      let payloadData = {
        kyc_data: kycobj,
        extra_data: extraobj,
        phone_no: phNo,
      };

      let response = await settingReduxData(unique_id, payloadData);

      return response;
    } catch (error) {}
  };

  // const settingData = async () => {
  //   try {
  //     let phNo = proposerData.Proposalphonenumber;

  //     let extraobj = {
  //       ...extraData,
  //       referralNo: referralNo,
  //     };

  //     let kycphoto = {
  //       docfront: selectedFile,
  //       docback: selectedBackFile,
  //       idfront: selectedIdentityFile,
  //       idback: selectedIdentityBackFile,
  //     };

  //     let kycobj = {
  //       ...kycData,
  //       addressDocType: selectedDocumentDrop,
  //       identityDocType: selectedIDType,
  //       kyc_photo: kycphoto,
  //       kyc_photo_path: kycpath,
  //       kyc_extension: kycExtension,
  //       form60_path: kycpath?.formpath || "",
  //       form60_extension: kycExtension?.formext || "",
  //     };

  //     let payloadData = {
  //       kyc_data: kycobj,
  //       extra_data: extraobj,
  //       phone_no: phNo,
  //     };

  //     let response = await settingReduxData(unique_id, payloadData);

  //     return response;
  //   } catch (error) {
  //     console.error("Error in settingData:", error);
  //   }
  // };

  const findMatchingInsured = (selectedRelation) => {
    if (!proposerData?.InsuredDetail) return;

    const matchedInsured = proposerData.InsuredDetail.find(
      (insured) => insured.InsuredRelation === selectedRelation
    );

    if (matchedInsured) {
      setKycData((prevData) => ({
        ...prevData,
        nomineeName: matchedInsured.InsuredName,
      }));
      validateFullName(matchedInsured.InsuredName);

      setKycData((prevData) => ({
        ...prevData,
        nomineedateOfbirth: matchedInsured.dateOfbirth,
      }));
      validateDobNom(matchedInsured.dateOfbirth);
    } else {
      setKycData((prevData) => ({
        ...prevData,
        nomineeName: "",
      }));
      validateFullName("");

      setKycData((prevData) => ({
        ...prevData,
        nomineedateOfbirth: "",
      }));
    }
  };

  useEffect(() => {
    getData();
  }, []);
  if (!apiResponse) {
    return (
      <div>
        <>
          <Redirect />
          <div className="container">
            <h1 className="mainheading">
              We Sell Happyness* <span className="middelheading">We Buy</span>
              <span className="endheading">Your Fear</span>{" "}
            </h1>
            <div className="row">
              <div className="col-md-8 ">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="skallitonformmedical"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="skallitonform00medical"
                />

                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform1"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform2"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform3"
                />

                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform4"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform5"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform6"
                />

                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform7"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform8"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform9"
                />

                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform10"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform11"
                />
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="kycform12"
                />
              </div>
              <div className="col-md-4 ">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="Summeryskalition"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="summeryheadtext"
                />
                <Skeleton
                  variant="circular"
                  animation="wave"
                  className="summeryAfterFetchimages"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="priceandtanureSummerySkalition"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText1"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText2"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText4"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText3"
                />
              </div>
            </div>
          </div>
        </>
      </div>
    );
  }

  if (!kycData) {
    if (!kycData?.firstname) {
      return (
        <div>
          <>
            <Redirect />
            <div className="container">
              <div className="row">
                <div className="col-lg-8 ">
                  <div className="propodsal_formsklition">
                    <div className="headersklition_propsal">
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform1"
                      />
                    </div>
                    <div className="propsal_frobody">
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform2"
                      />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform3"
                      />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform4"
                      />
                    </div>
                    <div className="propsal_frobody">
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform2"
                      />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform3"
                      />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform4"
                      />
                    </div>
                    <div className="propsal_frobody">
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform2"
                      />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform3"
                      />
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className="skallitonform4"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="summerySklition">
                    <div className="headerSklition">
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        className="summeryheadtext"
                      />
                    </div>
                    <div className="summerysklitonbody">
                      <Skeleton
                        variant="circular"
                        animation="wave"
                        className="summeryAfterFetchimages"
                      />
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        className="priceandtanureSummerySkalition"
                      />
                    </div>
                    <div className="sklitionbody2">
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        className="skalitionSummeryText1"
                      />
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        className="skalitionSummeryText1"
                      />
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        className="skalitionSummeryText1"
                      />
                    </div>

                    <div className="summeryfooterbody">
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        className="skalitionSummeryText3"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      );
    }
  }

  return (
    <>
      {loader && <Loader />}
      {
        <div className="container">
          <Redirect />
          <h1 className="mainheadings kyc">
            Amount is <span className="middelheading">Just a</span>
            <span className="endheading">Number</span>{" "}
          </h1>

          <br />
          <div className="row">
            <div className="col-lg-8 kycformdata">
              {c_id == "reliance" && retry_kyc && urldata && (
                <span className="kyc-error-url">
                  There is an issue with your online KYC. Kindly complete your
                  KYC manually by{" "}
                  <a href={urldata} className="kyc-error-click" target="_blank">
                    clicking here
                  </a>
                  .
                </span>
              )}

              {retry_kyc && c_id != "reliance" && (
                <div class="kyc-error-message">
                  <p>
                    {/* There is an error in your KYC, kindly upload your documents to proceed! */}

                    {decodedError ||
                      "There is an error in your KYC, kindly upload your documents to proceed!"}
                  </p>
                </div>
              )}

              <div className="nextsection m-0 ">
                <h1 className="kycheader">Proposal form (step 3 of 3)</h1>

                <p className="kycTOPICS">KYC Details</p>

                <div
                  className="row ppv10 my-3"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="First Name"
                        variant="standard"
                        required
                        value={kycData?.firstname ? kycData?.firstname : ""}
                        onChange={(e) => {
                          validateFirstName(e.target.value);
                          setKycData((prevData) => ({
                            ...prevData,
                            firstname: e.target.value,
                          }));
                        }}
                        error={!!firstNameErr}
                        helperText={firstNameErr}
                      />
                    </div>
                  </div>

                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="Middle Name"
                        variant="standard"
                        value={kycData?.middlename || ""}
                        error={!!middleNameErr}
                        helperText={middleNameErr}
                        onChange={(e) => {
                          validateMiddleName(e.target.value);
                          setKycData((prevData) => ({
                            ...prevData,
                            middlename: e.target.value,
                          }));
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="Last Name"
                        variant="standard"
                        required
                        value={kycData?.lastname ? kycData?.lastname : ""}
                        onChange={(e) => {
                          validateLastName(e.target.value);
                          setKycData((prevData) => ({
                            ...prevData,
                            lastname: e.target.value,
                          }));
                        }}
                        error={!!lastNameErr}
                        helperText={lastNameErr}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="row  ppv10 my-3"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <FormControl variant="standard" sx={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-standard-label"
                          style={{ fontFamily: "12pt" }}
                        >
                          Doc Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={kycData?.kycId || ""}
                          onChange={(e) => {
                            validateDocType(e.target.value);
                            setKycData((prevData) => ({
                              ...prevData,
                              kycId: e.target.value,
                            }));
                          }}
                        >
                          {kycOptions.map((data) => (
                            <MenuItem key={data.value} value={data.value}>
                              {data.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <span style={{ color: "red", fontSize: "9pt" }}>
                        {docTypeErr && (
                          <p className="error-message red-text">{docTypeErr}</p>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DesktopDatePicker"]}>
                          <DesktopDatePicker
                            style={{ width: "100%" }}
                            variant="standard"
                            id="standard-helperText"
                            label="DOB"
                            value={
                              kycData?.KycdateOfbirth &&
                              dayjs(kycData?.KycdateOfbirth)
                                ? kycData?.KycdateOfbirth &&
                                  dayjs(kycData?.KycdateOfbirth)
                                : ""
                            }
                            onChange={(e) => {
                              validateDob(e);
                              setKycData((prevData) => ({
                                ...prevData,
                                KycdateOfbirth: getDate(e),
                              }));
                            }}
                            format="DD-MM-YYYY"
                            required
                            sx={{
                              "& .MuiInputBase-root": {
                                boxShadow: "none",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: 0,
                                  },
                              },
                              "& .MuiInputBase-input": {
                                padding: "10px 5px", // Adjust padding as needed
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      {dobErr && (
                        <p className="error-message red-text">{dobErr}</p>
                      )}
                    </div>
                  </div>

                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="Doc Number"
                        defaultValue=""
                        variant="standard"
                        error={!!docNumErr}
                        helperText={docNumErr}
                        value={kycData?.cardNum || ""}
                        onChange={(e) => {
                          validateDocNumber(e.target.value?.toUpperCase());
                          setKycData((prevData) => ({
                            ...prevData,
                            cardNum: e.target.value?.toUpperCase(),
                          }));
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>

                {showForm && c_id == "star" && (
                  <div
                    className="row  ppv10 my-3"
                    style={{ paddingRight: "10px", paddingLeft: "10px" }}
                  >
                    <div className="col-md px-0 py-2">
                      <div className="prpfbd">
                        <FormControl variant="standard" sx={{ width: "100%" }}>
                          <InputLabel
                            id="demo-simple-select-standard-label"
                            style={{ fontFamily: "12pt" }}
                          >
                            Do You Have Pan Card ?
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={kycData?.kycPan || ""}
                            onChange={(e) => {
                              validatePanCheck(e.target.value);
                              setKycData((prevData) => ({
                                ...prevData,
                                kycPan: e.target.value,
                              }));
                            }}
                          >
                            {panOptions.map((data) => (
                              <MenuItem key={data.value} value={data.value}>
                                {data.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <span style={{ color: "red", fontSize: "9pt" }}>
                          {docTypeErrPan && (
                            <p className="error-message red-text">
                              {docTypeErrPan}
                            </p>
                          )}
                        </span>
                      </div>
                    </div>

                    {showForm16 && (
                      <div className="col-md px-0 py-2">
                        <div className="prpfbd">
                          <FormControl
                            variant="standard"
                            sx={{ width: "100%" }}
                          >
                            <InputLabel
                              shrink
                              htmlFor="form60-upload"
                              style={{
                                fontSize: "20px",
                                fontWeight: 700,
                                marginBottom: "10px",
                                color: "#000",
                              }}
                            >
                              Upload your Form 60
                            </InputLabel>

                            <input
                              id="form60-upload"
                              type="file"
                              accept=".pdf,.jpg,.jpeg,.png"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e, "form60");
                              }}
                            />

                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                marginTop: "22px",
                              }}
                            >
                              <label htmlFor="form60-upload">
                                <div
                                  style={{
                                    display: "inline-block",
                                    padding: "4px 8px",
                                    fontSize: "13px",
                                    backgroundColor: "rgb(0, 85, 165)",
                                    color: "#fff",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    width: "fit-content",
                                  }}
                                >
                                  Choose File
                                </div>
                              </label>

                              <div
                                style={{
                                  fontSize: "17px",
                                  maxWidth: "300px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {/* {console.log("form60Front", form60Front)} */}

                                {form60Front ? (
                                  <a
                                    href={`${process.env.REACT_APP_MAIN_URL}/${kycpath?.form60path}`}
                                    target="_blank"
                                    // rel="noopener noreferrer"
                                    style={{
                                      color: "#0055a5",
                                      textDecoration: "underline",
                                      fontWeight: 500,
                                    }}
                                    // title={form60Front}
                                  >
                                    {form60Front.length > 25
                                      ? `${form60Front.slice(0, 25)}...`
                                      : form60Front}
                                  </a>
                                ) : (
                                  <span style={{ color: "#888" }}>
                                    No file chosen
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormControl>

                          {docTypeErrPanFile && (
                            <span style={{ color: "red", fontSize: "9pt" }}>
                              <p className="error-message red-text">
                                {docTypeErrPanFile}
                              </p>
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {!showForm16 && showForm16 != null && (
                      <div className="col-md px-0 py-2">
                        <div className="prpfbd">
                          <FormControl
                            variant="standard"
                            sx={{ width: "100%" }}
                          >
                            <TextField
                              id="pan-input"
                              label="Enter your Pan number"
                              variant="standard"
                              value={kycData?.kycPanNum || ""}
                              onChange={(e) => {
                                validatePanNumCheck(e.target.value);
                                setKycData((prevData) => ({
                                  ...prevData,
                                  kycPanNum: e.target.value,
                                }));
                              }}
                              InputLabelProps={{
                                style: { fontSize: "12pt" },
                              }}
                            />
                          </FormControl>

                          <span style={{ color: "red", fontSize: "9pt" }}>
                            {docTypeErrPanNum && (
                              <p className="error-message red-text">
                                {docTypeErrPanNum}
                              </p>
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="col-md px-0 py-2">
                  {(c_id !== "reliance" ||
                    c_id === "star" ||
                    c_id === "icici") && (
                    <>
                      <div class="line-container">
                        <hr class="kychr" />
                        <p class="kycseparator">Document Upload</p>
                        <hr class="kychr" />
                      </div>

                      <Box className="col-md px-0 py-2">
                        <Box display="flex" flexDirection="column" gap="16px">
                          <Box mb={3}>
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#33333391",
                                marginBottom: "15px",
                                paddingLeft: "5px",
                                fontWeight: "500",
                                fontSize: "17px",

                                width: "fit-content",

                                padding: "5px",
                                borderRadius: "5px",
                                color: "#236fc0",
                                backgroundColor: "aliceblue",
                              }}
                            >
                              Address Proof
                            </Typography>

                            <Box display="flex" flexDirection="row">
                              <Box
                                display="flex"
                                flexWrap="wrap"
                                className="col-md-12"
                                sx={{
                                  paddingLeft: "0px",
                                }}
                              >
                                <FormControl
                                  variant="standard"
                                  className="col-md-4"
                                >
                                  <InputLabel
                                    id="select-id-type-label"
                                    style={{ fontFamily: "12pt" }}
                                  >
                                    Select Document
                                  </InputLabel>
                                  <Select
                                    labelId="select-id-type-label"
                                    id="select-id-type"
                                    value={selectedDocumentDrop || ""}
                                    onChange={(e) => {
                                      handleChangeDrop(e);
                                      validateAddressProof(e.target.value);
                                      setKycData((prevData) => ({
                                        ...prevData,
                                        kycaddressproof: e.target.value,
                                      }));
                                    }}
                                    sx={{ color: "#555" }}
                                    displayEmpty
                                  >
                                    {addressOptions.map((item) => (
                                      <MenuItem
                                        key={item.value}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                  <span
                                    style={{ color: "red", fontSize: "9pt" }}
                                  >
                                    {addressPrfErr && (
                                      <p className="error-message red-text">
                                        {addressPrfErr}
                                      </p>
                                    )}
                                  </span>
                                </FormControl>

                                <Box
                                  flex="1"
                                  className="col-md-4"

                                  // minWidth="250px"
                                >
                                  <Button
                                    variant="contained"
                                    component="label"
                                    fullWidth
                                    sx={{
                                      marginTop: "8px",
                                      textTransform: "none",

                                      padding: "5px",
                                      borderRadius: "8px",
                                      backgroundColor: "#2196f3",
                                      color: "white",
                                      "&:hover": {
                                        backgroundColor: "#1976d2",
                                      },

                                      paddingLeft: "5px",
                                    }}
                                  >
                                    {selectedFile
                                      ? "Change Document (Front)"
                                      : "Upload Document (Front)"}
                                    <input
                                      type="file"
                                      hidden
                                      accept=".pdf, .jpeg, .jpg, .png, .tiff, .tif"
                                      onChange={(e) => {
                                        handleFileChange(e, "document");
                                      }}
                                    />
                                  </Button>
                                  {fileError && (
                                    <Typography
                                      color="error"
                                      sx={{
                                        marginTop: "8px",
                                        fontSize: "0.875em",
                                      }}
                                    >
                                      {fileError}
                                    </Typography>
                                  )}

                                  {selectedFile && (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      mt={1}
                                      style={{
                                        display: "flex",
                                        alignItems: "start",
                                        justifyContent: " space-between",
                                      }}
                                    >
                                      {renderImagePreview(selectedFile)}
                                      <Button
                                        onClick={() => {
                                          setSelectedFile("");
                                          setDocFront("");
                                          setKycPath((prevState) => ({
                                            ...prevState,
                                            docfrontpath: "",
                                          }));
                                          setKycExtension((prevState) => ({
                                            ...prevState,
                                            docfrontext: "",
                                          }));
                                        }}
                                        sx={{
                                          marginLeft: "8px",
                                          backgroundColor: "#e80808d1",
                                          borderRadius: "50%",

                                          width: "24px",
                                          minWidth: "15px",
                                          height: "22px",
                                          color: "white",
                                          "&:hover": {
                                            backgroundColor: "#e80808d1",
                                          },
                                        }}
                                      >
                                        ✖
                                      </Button>
                                    </Box>
                                  )}
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="medium"
                                    sx={{
                                      color: "#333",
                                      marginBottom: "8px",
                                      color: "#33333399",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    {docFront ? `${docFront}` : ""}
                                  </Typography>
                                </Box>

                                {c_id != "icici" && plan_id != "unknown" && (
                                  <Box flex="1" className="col-md-4">
                                    <Button
                                      variant="contained"
                                      component="label"
                                      fullWidth
                                      sx={{
                                        marginTop: "8px",
                                        textTransform: "none",

                                        padding: "5px",
                                        borderRadius: "8px",
                                        backgroundColor: "#2196f3",
                                        color: "white",
                                        "&:hover": {
                                          backgroundColor: "#1976d2",
                                        },
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {c_id != "star" &&
                                        (selectedBackFile
                                          ? "Change Document (Back)"
                                          : "Upload Document (Back)")}

                                      {c_id == "star" &&
                                        (selectedBackFile
                                          ? "Change Photo"
                                          : "Upload Photo")}

                                      <input
                                        type="file"
                                        hidden
                                        accept=".pdf, .jpeg, .jpg, .png, .tiff, .tif"
                                        onChange={(e) => {
                                          handleFileChange(e, "documentBack");
                                          validateAddPhoto(e.target.files[0]);
                                        }}
                                      />
                                    </Button>
                                    {fileErrorBack && (
                                      <Typography
                                        color="error"
                                        sx={{
                                          marginTop: "8px",
                                          fontSize: "0.875em",
                                        }}
                                      >
                                        {fileErrorBack}
                                      </Typography>
                                    )}

                                    {selectedBackFile && (
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        mt={1}
                                        style={{
                                          display: "flex",
                                          alignItems: "start",

                                          justifyContent: " space-between",
                                        }}
                                      >
                                        {renderImagePreview(selectedBackFile)}
                                        <Button
                                          onClick={() => {
                                            setSelectedBackFile("");
                                            setDocBack("");
                                            setKycPath((prevState) => ({
                                              ...prevState,
                                              docbackpath: "",
                                            }));
                                            setKycExtension((prevState) => ({
                                              ...prevState,
                                              docbackext: "",
                                            }));
                                          }}
                                          sx={{
                                            marginLeft: "8px",
                                            backgroundColor: "#e80808d1",
                                            borderRadius: "50%",

                                            width: "24px",
                                            minWidth: "15px",
                                            height: "22px",
                                            color: "white",
                                            "&:hover": {
                                              backgroundColor: "#e80808d1",
                                            },
                                          }}
                                        >
                                          ✖
                                        </Button>
                                      </Box>
                                    )}
                                    <Typography
                                      variant="subtitle1"
                                      fontWeight="medium"
                                      sx={{
                                        color: "#333",
                                        marginBottom: "8px",
                                        color: "#33333399",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {docBack ? `${docBack}` : ""}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Box>

                          {c_id != "star" && (
                            <Box mb={3}>
                              <Typography
                                variant="h6"
                                sx={{
                                  color: "#33333391",
                                  marginBottom: "15px",
                                  paddingLeft: "5px",
                                  fontWeight: "500",
                                  fontSize: "17px",
                                  width: "fit-content",

                                  padding: "5px",
                                  borderRadius: "5px",
                                  color: "#236fc0",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                Identity Proof
                              </Typography>

                              <Box
                                display="flex"
                                flexWrap="wrap"
                                className="col-md-12"
                                sx={{
                                  paddingLeft: "0px",
                                }}
                              >
                                <FormControl
                                  variant="standard"
                                  className="col-md-4"
                                >
                                  <InputLabel
                                    id="select-id-type-label"
                                    style={{ fontFamily: "12pt" }}
                                  >
                                    Select ID
                                  </InputLabel>
                                  <Select
                                    labelId="select-id-type-label"
                                    id="select-id-type"
                                    value={selectedIDType || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      validateIdProof(e.target.value);
                                      setKycData((prevData) => ({
                                        ...prevData,
                                        kycidproof: e.target.value,
                                      }));
                                    }}
                                    sx={{ color: "#555" }}
                                    displayEmpty
                                  >
                                    {identityOptions.map((item) => (
                                      <MenuItem
                                        key={item.value}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                  {idErrorSelect && (
                                    <Typography
                                      color="error"
                                      sx={{
                                        marginTop: "8px",
                                        fontSize: "0.875em",
                                      }}
                                    >
                                      {idErrorSelect}
                                    </Typography>
                                  )}
                                </FormControl>
                                <Box flex="1" className="col-md-4">
                                  <Button
                                    variant="contained"
                                    component="label"
                                    fullWidth
                                    sx={{
                                      marginTop: "8px",
                                      textTransform: "none",

                                      borderRadius: "8px",
                                      backgroundColor: "#2196f3",
                                      color: "white",
                                      "&:hover": {
                                        backgroundColor: "#1976d2",
                                      },
                                    }}
                                  >
                                    {selectedIdentityFile
                                      ? "Change Identity (Front)"
                                      : "Upload Identity (Front)"}
                                    <input
                                      type="file"
                                      hidden
                                      accept=".pdf, .jpeg, .jpg, .png, .tiff, .tif"
                                      onChange={(e) =>
                                        handleFileChange(e, "identity")
                                      }
                                    />
                                  </Button>
                                  {identityFileError && (
                                    <Typography
                                      color="error"
                                      sx={{
                                        marginTop: "8px",
                                        fontSize: "0.875em",
                                      }}
                                    >
                                      {identityFileError}
                                    </Typography>
                                  )}

                                  {selectedIdentityFile && (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      mt={1}
                                      style={{
                                        display: "flex",
                                        justifyContent: " space-between",
                                        alignItems: "start",
                                      }}
                                    >
                                      {renderImagePreview(selectedIdentityFile)}
                                      <Button
                                        onClick={() => {
                                          setSelectedIdentityFile("");
                                          setIdFront("");
                                          setKycPath((prevState) => ({
                                            ...prevState,
                                            idfrontpath: "",
                                          }));
                                          setKycExtension((prevState) => ({
                                            ...prevState,
                                            idfrontext: "",
                                          }));
                                        }}
                                        sx={{
                                          marginLeft: "8px",
                                          backgroundColor: "#e80808d1",
                                          borderRadius: "50%",

                                          width: "24px",
                                          minWidth: "15px",
                                          height: "22px",
                                          color: "white",
                                          "&:hover": {
                                            backgroundColor: "#e80808d1",
                                          },
                                        }}
                                      >
                                        ✖
                                      </Button>
                                    </Box>
                                  )}
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="medium"
                                    sx={{
                                      color: "#333",
                                      marginBottom: "8px",
                                      color: "#33333399",
                                      paddingLeft: "5px",
                                      // textAlign:"center"
                                    }}
                                  >
                                    {idFront ? `${idFront}` : ""}
                                  </Typography>
                                </Box>

                                {plan_id != "unknown" && c_id == "icici" && (
                                  <Box flex="1" className="col-md-4">
                                    <Button
                                      variant="contained"
                                      component="label"
                                      fullWidth
                                      sx={{
                                        marginTop: "8px",
                                        textTransform: "none",

                                        padding: "5px",
                                        borderRadius: "8px",
                                        backgroundColor: "#2196f3",
                                        color: "white",
                                        "&:hover": {
                                          backgroundColor: "#1976d2",
                                        },
                                      }}
                                    >
                                      {c_id != "star" &&
                                        (selectedIdentityBackFile
                                          ? "Change Identity (Back)"
                                          : "Upload Identity (Back)")}

                                      {c_id == "star" &&
                                        (selectedIdentityBackFile
                                          ? "Change Photo"
                                          : "Upload Photo")}
                                      <input
                                        type="file"
                                        hidden
                                        accept=".pdf, .jpeg, .jpg, .png, .tiff, .tif"
                                        onChange={(e) =>
                                          handleFileChange(e, "identityBack")
                                        }
                                      />
                                    </Button>
                                    {identityFileErrorBack && (
                                      <Typography
                                        color="error"
                                        sx={{
                                          marginTop: "8px",
                                          fontSize: "0.875em",
                                        }}
                                      >
                                        {identityFileErrorBack}
                                      </Typography>
                                    )}

                                    {selectedIdentityBackFile && (
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        mt={1}
                                        style={{
                                          display: "flex",
                                          justifyContent: " space-between",
                                          alignItems: "start",
                                        }}
                                      >
                                        {renderImagePreview(
                                          selectedIdentityBackFile
                                        )}
                                        <Button
                                          onClick={() => {
                                            setSelectedIdentityBackFile("");
                                            setIdBack("");
                                            setKycPath((prevState) => ({
                                              ...prevState,
                                              idbackpath: "",
                                            }));
                                            setKycExtension((prevState) => ({
                                              ...prevState,
                                              idbackext: "",
                                            }));
                                          }}
                                          sx={{
                                            marginLeft: "8px",
                                            backgroundColor: "#e80808d1",
                                            borderRadius: "50%",

                                            width: "24px",
                                            minWidth: "15px",

                                            height: "22px",
                                            color: "white",
                                            "&:hover": {
                                              backgroundColor: "#e80808d1",
                                            },
                                          }}
                                        >
                                          ✖
                                        </Button>
                                      </Box>
                                    )}
                                    <Typography
                                      variant="subtitle1"
                                      fontWeight="medium"
                                      sx={{
                                        color: "#333",
                                        marginBottom: "8px",
                                        color: "#33333399",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      {idback ? `${idback}` : ""}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                </div>
                <div className="row col-md-4  ppv10 my-3">
                  {c_id == "hdfc" ? (
                    <div className="col px-0">
                      <div className="prpfbd relnomfix">
                        <FormControl variant="standard" sx={{ width: "100%" }}>
                          <InputLabel id="demo-simple-select-standard-label">
                            Relationship With Nominee
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            onChange={(e) => {
                              validateNomineeRelation(e.target.value);

                              setKycData((prevData) => ({
                                ...prevData,
                                RelationWithNominee: e.target.value,
                              }));
                            }}
                            value={kycData.RelationWithNominee}
                            required
                          >
                            {hdfcnomine.map((data) => {
                              return (
                                <MenuItem value={data.value}>
                                  {data.label}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>

                        <span style={{ color: "red", fontSize: "9pt" }}>
                          {nomRelErr}
                        </span>
                      </div>
                    </div>
                  ) : null}
                </div>

                {/* ---------- Communication details------------------- */}
                <p className="kycTOPICS commun-fix">Communication Details</p>

                <div
                  className="row ppv10 my-3"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="Mobile Number"
                        variant="standard"
                        disabled
                        value={proposerData?.Proposalphonenumber || ""}
                      />
                    </div>
                  </div>

                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <FormControl fullWidth>
                        <TextField
                          style={{ width: "100%" }}
                          id="standard-helperText"
                          label="State"
                          value={
                            (proposerData?.Sate && proposerData.Sate) || ""
                          }
                          variant="standard"
                          required
                          disabled
                        />
                      </FormControl>
                    </div>
                  </div>

                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <FormControl fullWidth>
                        <TextField
                          style={{ width: "100%" }}
                          id="standard-helperText"
                          label="District"
                          value={proposerData?.District || ""}
                          variant="standard"
                          required
                          disabled
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div
                  className="row ppv10 my-3"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        type="text"
                        id="standard-helperText"
                        label="Email Id"
                        defaultValue=""
                        variant="standard"
                        value={kycData?.Email || ""}
                        onChange={(e) => {
                          validateEmail(e.target.value);
                          setKycData((prevData) => ({
                            ...prevData,
                            Email: e.target.value,
                          }));
                        }}
                        error={!!emailError}
                        helperText={emailError}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        value={kycData?.PinCode ? kycData?.PinCode : ""}
                        options={pinCodeList || []}
                        sx={{
                          width: 300,
                          "& .MuiInputBase-root": {
                            boxShadow: "none",
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: 0,
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              border: 0,
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              border: 0,
                            },
                          },
                          "& .MuiInputBase-input": {
                            padding: "10px 5px",
                          },
                        }}
                        onChange={(event, e) => {
                          validatePinCode(e?.label);
                          setKycData((prevData) => ({
                            ...prevData,
                            PinCode: e?.label || "",
                          }));
                        }}
                        required
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Pincode"
                            variant="standard"
                          />
                        )}
                        style={{
                          width: "70%",
                          textOverflow: "unset",
                          minWidth: "60px",
                        }}
                      />

                      <>
                        <p
                          style={{
                            color: " #d32f2f",
                            fontWeight: "400",
                            fontSize: "13px",
                          }}
                        >
                          {pinError && (
                            <p className="error-message red-text">{pinError}</p>
                          )}
                        </p>
                      </>
                    </div>
                  </div>
                </div>

                <div
                  className="row ppv10 my-3"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col-md px-0 py-2 addfix">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="Address"
                        defaultValue=""
                        variant="standard"
                        required
                        value={kycData?.street || ""}
                        onChange={(e) => {
                          validateStreet(e.target.value);

                          setKycData((prevData) => ({
                            ...prevData,
                            street: e.target.value,
                          }));
                        }}
                        onBlur={(e) => {
                          if (!kycData?.nomineeAddress) {
                            validateNomAddress(e.target.value);

                            setKycData((prevData) => ({
                              ...prevData,
                              nomineeAddress: e.target.value,
                            }));
                          }
                        }}
                        error={!!kycAddressError}
                        helperText={kycAddressError}
                      />
                    </div>
                  </div>
                </div>

                <p className="kycTOPICS">Nominee Details</p>

                <div
                  className="row  ppv10 my-3"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <FormControl variant="standard" sx={{ width: "90%" }}>
                        <InputLabel
                          id="demo-simple-select-standard-label"
                          style={{ fontSize: "14px" }}
                        >
                          Relationship With Proposer
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          label="Age"
                          value={kycData?.nomineerelationship || ""}
                          onChange={(e) => {
                            validateRelationship(e.target.value);
                            findMatchingInsured(e.target.value);
                            setKycData((prevData) => ({
                              ...prevData,
                              nomineerelationship: e.target.value,
                            }));
                          }}
                        >
                          {c_id === "reliance"
                            ? relincenomine.map((data, i) => (
                                <MenuItem key={data.value} value={data.value}>
                                  {data.label}
                                </MenuItem>
                              ))
                            : c_id == "hdfc"
                            ? hdfcnomine.map((data, i) => (
                                <MenuItem key={data.value} value={data.value}>
                                  {data.label}
                                </MenuItem>
                              ))
                            : OtherNominie.map((data, i) => (
                                <MenuItem key={data.value} value={data.value}>
                                  {data.label}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>

                      {nomRelErr && (
                        <p className="error-message red-text">{nomRelErr}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <TextField
                        style={{ width: "100%" }}
                        id="standard-helperText"
                        label="Full Name"
                        defaultValue=""
                        variant="standard"
                        value={kycData?.nomineeName || ""}
                        onChange={(e) => {
                          validateFullName(e.target.value);
                          setKycData((prevData) => ({
                            ...prevData,
                            nomineeName: e.target.value,
                          }));
                        }}
                        required
                        error={!!nomNameErr}
                        helperText={nomNameErr}
                      />
                    </div>
                  </div>
                  <div className="col-md px-0 py-2">
                    <div className="prpfbd">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DesktopDatePicker"]}>
                          <DesktopDatePicker
                            style={{ width: "100%" }}
                            variant="standard"
                            id="standard-helperText"
                            label="DOB"
                            value={
                              (kycData?.nomineedateOfbirth &&
                                dayjs(kycData?.nomineedateOfbirth)) ||
                              ""
                            }
                            onChange={(e) => {
                              validateDobNom(e);
                              setKycData((prevData) => ({
                                ...prevData,
                                nomineedateOfbirth: getDate(e),
                              }));
                            }}
                            format="DD-MM-YYYY"
                            required
                            sx={{
                              "& .MuiInputBase-root": {
                                boxShadow: "none",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: 0,
                                  },
                              },
                              "& .MuiInputBase-input": {
                                padding: "10px 5px",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      {nomDobErr && (
                        <p className="error-message red-text">{nomDobErr}</p>
                      )}
                    </div>
                  </div>
                </div>

                {c_id == "hdfc" && (
                  <div
                    className="row  ppv10"
                    style={{ paddingRight: "10px", paddingLeft: "10px" }}
                  >
                    <div className="col-md px-0 py-2">
                      <div className="prpfbd" style={{ position: "relative" }}>
                        <TextField
                          id="standard-helperText"
                          label="State"
                          variant="standard"
                          disabled
                          required
                          value={kycData?.nomState || ""}
                          onChange={(e) => {
                            validateNomState(e.target.value);
                            setKycData((prevData) => ({
                              ...prevData,
                              nomState: e.target.value,
                            }));
                          }}
                          error={!!nomStateError}
                          helperText={nomStateError}
                          style={{ width: "100%", paddingRight: "30px" }}
                        />
                      </div>
                    </div>

                    <div className="col-md px-0 py-2">
                      <div className="prpfbd" style={{ position: "relative" }}>
                        <TextField
                          id="standard-helperText"
                          label="City"
                          variant="standard"
                          disabled
                          required
                          value={kycData?.nomCity || ""}
                          onChange={(e) => {
                            validateNomCity(e.target.value);
                            setKycData((prevData) => ({
                              ...prevData,
                              nomCity: e.target.value,
                            }));
                          }}
                          error={!!nomCityError}
                          helperText={nomCityError}
                          style={{ width: "100%", paddingRight: "30px" }} // Ensure space for button
                        />
                      </div>
                    </div>

                    <div className="col-md px-0 py-2">
                      <div className="prpfbd">
                        <Autocomplete
                          id="combo-box-demo"
                          disablePortal
                          value={
                            pinCodeListNom.find(
                              (item) => item.label === kycData?.PinCodeNom
                            ) || null
                          }
                          options={pinCodeListNom || []}
                          filterOptions={filterOptions}
                          getOptionLabel={(option) => option.label || ""}
                          onChange={(event, selectedOption) => {
                            if (selectedOption) {
                              validatePinCodeNom(selectedOption.label);
                              setKycData((prevData) => ({
                                ...prevData,
                                PinCodeNom: selectedOption.label,
                                nomCity: selectedOption.District,
                                nomState: selectedOption.StateName,
                              }));
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Pincode"
                              variant="standard"
                              autoComplete="off"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                          required
                          sx={{
                            width: "70%",
                            minWidth: "60px",
                            "& .MuiInputBase-root": {
                              boxShadow: "none",
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: 0,
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: 0,
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            },
                            "& .MuiInputBase-input": {
                              padding: "10px 5px",
                            },
                          }}
                        />

                        <>
                          <p
                            style={{
                              color: " #d32f2f",
                              fontWeight: "400",
                              fontSize: "13px",
                            }}
                          >
                            {pinErrorNom && (
                              <p className="error-message red-text">
                                {pinErrorNom}
                              </p>
                            )}
                          </p>
                        </>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className="row ppv10 my-3 col-md-12 justify-content-center"
                  style={{ paddingRight: "10px", paddingLeft: "10px" }}
                >
                  <div className="col px-0">
                    {c_id == "reliance" && (
                      <div className="prpfbd" style={{ width: "30%" }}>
                        <TextField
                          id="standard-helperText"
                          label="Nominee Phone Number"
                          defaultValue=""
                          variant="standard"
                          value={kycData?.nomineePhoneNumber || ""}
                          onChange={(e) => {
                            validateNomPhoneNumber(e.target.value);
                            setKycData((prevData) => ({
                              ...prevData,
                              nomineePhoneNumber: e.target.value,
                            }));
                          }}
                          error={!!nomPhoneError}
                          helperText={nomPhoneError}
                          style={{ width: "100%" }}
                        />
                      </div>
                    )}

                    <div
                      className="prpfbd"
                      style={{ position: "relative", width: "100%" }}
                    >
                      <TextField
                        id="standard-helperText"
                        label="Address"
                        variant="standard"
                        required
                        value={kycData?.nomineeAddress || ""}
                        onChange={(e) => {
                          validateNomAddress(e.target.value);
                          setKycData((prevData) => ({
                            ...prevData,
                            nomineeAddress: e.target.value,
                          }));
                        }}
                        onBlur={(e) => {
                          if (!kycData?.apointeeAddress) {
                            validateApointeeAddress(e.target.value);

                            setKycData((prevData) => ({
                              ...prevData,
                              apointeeAddress: e.target.value,
                            }));
                          }
                        }}
                        error={!!nomAddressError}
                        helperText={nomAddressError}
                        style={{ width: "100%", paddingRight: "30px" }}
                      />

                      {kycData?.nomineeAddress && (
                        <button
                          onClick={() =>
                            setKycData((prevData) => ({
                              ...prevData,
                              nomineeAddress: "",
                            }))
                          }
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "#888",
                          }}
                        >
                          ❌
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* ---------------------------------------------------------------------------------------- */}

                {showApointee && c_id == "hdfc" && (
                  <>
                    <div style={{ marginBottom: "30px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "30px 0",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            borderBottom: "2px dotted #999",
                          }}
                        ></div>
                        <span
                          style={{
                            padding: "0 15px",
                            fontWeight: "700",
                            fontSize: "17px",
                            color: "#2959b8",
                            whiteSpace: "nowrap",
                            letterSpacing: "1px",
                          }}
                        >
                          Apointee Details
                        </span>
                        <div
                          style={{
                            flex: 1,
                            borderBottom: "2px dotted #999",
                          }}
                        ></div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          color: "rgb(153 139 139 / 98%)",
                          marginTop: "-29px",
                          marginBottom: "20px",
                        }}
                      >
                        ( Please provide these details as the nominee age is
                        under 18 )
                      </div>

                      <div
                        className="row  ppv10"
                        style={{ paddingRight: "10px", paddingLeft: "10px" }}
                      >
                        <div className="col-md px-0 py-2">
                          <div className="prpfbd">
                            <FormControl
                              variant="standard"
                              sx={{ width: "90%" }}
                            >
                              <InputLabel
                                id="demo-simple-select-standard-label"
                                style={{ fontSize: "14px" }}
                              >
                                Relationship With Nominee
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Age"
                                value={kycData?.apointeerelationship || ""}
                                onChange={(e) => {
                                  validateApointeeRelationship(e.target.value);

                                  setKycData((prevData) => ({
                                    ...prevData,
                                    apointeerelationship: e.target.value,
                                  }));
                                }}
                              >
                                {apointeeData.map((data, i) => (
                                  <MenuItem key={data.Key} value={data.Data}>
                                    {data.Data}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>

                            {appointeeRelErr && (
                              <p className="error-message red-text">
                                {appointeeRelErr}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-md px-0 py-2">
                          <div className="prpfbd">
                            <TextField
                              style={{ width: "100%" }}
                              id="standard-helperText"
                              label="Full Name"
                              defaultValue=""
                              variant="standard"
                              value={kycData?.apointeeName || ""}
                              onChange={(e) => {
                                validateApointeeFullName(e.target.value);
                                setKycData((prevData) => ({
                                  ...prevData,
                                  apointeeName: e.target.value,
                                }));
                              }}
                              required
                              error={!!appointeeNameErr}
                              helperText={appointeeNameErr}
                            />
                          </div>
                        </div>

                        <div className="col-md px-0 py-2">
                          <div className="prpfbd">
                            <Autocomplete
                              id="combo-box-demo"
                              disablePortal
                              value={
                                pinCodeListNom.find(
                                  (item) =>
                                    item.label === kycData?.PinCodeApointee
                                ) || null
                              }
                              options={pinCodeListNom || []}
                              filterOptions={filterOptions}
                              getOptionLabel={(option) => option.label || ""}
                              onChange={(event, selectedOption) => {
                                if (selectedOption) {
                                  validatePinCodeApointee(selectedOption.label);
                                  setKycData((prevData) => ({
                                    ...prevData,
                                    PinCodeApointee: selectedOption.label,
                                    apointeeCity: selectedOption.District,
                                    apointeeState: selectedOption.StateName,
                                  }));
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Pincode"
                                  variant="standard"
                                  autoComplete="off"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "new-password", // Helps prevent Chrome autofill
                                  }}
                                />
                              )}
                              required
                              sx={{
                                width: "70%",
                                minWidth: "60px",
                                "& .MuiInputBase-root": {
                                  boxShadow: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: 0,
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: 0,
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: 0,
                                    },
                                },
                                "& .MuiInputBase-input": {
                                  padding: "10px 5px",
                                },
                              }}
                            />

                            <>
                              <p
                                style={{
                                  color: " #d32f2f",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                }}
                              >
                                {pinErrorApointee && (
                                  <p className="error-message red-text">
                                    {pinErrorApointee}
                                  </p>
                                )}
                              </p>
                            </>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row  ppv10"
                        style={{ paddingRight: "10px", paddingLeft: "10px" }}
                      >
                        <div className="col-md px-0 py-2">
                          <div
                            className="prpfbd"
                            style={{ position: "relative" }}
                          >
                            <TextField
                              id="standard-helperText"
                              label="State"
                              variant="standard"
                              disabled
                              required
                              value={kycData?.apointeeState || ""}
                              onChange={(e) => {
                                validateApointeeState(e.target.value);
                                setKycData((prevData) => ({
                                  ...prevData,
                                  apointeeState: e.target.value,
                                }));
                              }}
                              error={!!appointeeStateError}
                              helperText={appointeeStateError}
                              style={{ width: "100%", paddingRight: "30px" }}
                            />
                          </div>
                        </div>

                        <div className="col-md px-0 py-2">
                          <div
                            className="prpfbd"
                            style={{ position: "relative" }}
                          >
                            <TextField
                              id="standard-helperText"
                              label="City"
                              variant="standard"
                              disabled
                              required
                              value={kycData?.apointeeCity || ""}
                              onChange={(e) => {
                                validateApointeeCity(e.target.value);
                                setKycData((prevData) => ({
                                  ...prevData,
                                  apointeeCity: e.target.value,
                                }));
                              }}
                              error={!!appointeeCityError}
                              helperText={appointeeCityError}
                              style={{ width: "100%", paddingRight: "30px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="row  ppv10"
                        style={{ paddingRight: "10px", paddingLeft: "10px" }}
                      >
                        <div className="col-md px-0 py-2">
                          <div
                            className="prpfbd"
                            style={{ position: "relative" }}
                          >
                            <TextField
                              id="standard-helperText"
                              label="Address"
                              variant="standard"
                              required
                              value={kycData?.apointeeAddress || ""}
                              onChange={(e) => {
                                validateApointeeAddress(e.target.value);
                                setKycData((prevData) => ({
                                  ...prevData,
                                  apointeeAddress: e.target.value,
                                }));
                              }}
                              error={!!appointeeAddressError}
                              helperText={appointeeAddressError}
                              style={{ width: "100%", paddingRight: "30px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* -------------------------------------------------------------------------------------------------------------  */}

                {["hdfc", "care"].includes(c_id) ||
                  (c_id == "star" && plan_id == "SUPERSTARIND" && (
                    <>
                      <p className="kycTOPICS">Bank Details</p>

                      <div
                        className="row ppv10 my-3"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          paddingRight: "10px",
                          paddingLeft: "10px",
                        }}
                      >
                        <div className="col-md-6 px-0 py-2">
                          <div className="prpfbd">
                            <TextField
                              style={{ width: "100%" }}
                              type="text"
                              id="standard-helperText"
                              label="Name"
                              variant="standard"
                              value={kycData?.Name || ""}
                              onChange={(e) => {
                                setKycData((prevData) => ({
                                  ...prevData,
                                  Name: e.target.value,
                                }));
                                validateName(e.target.value);
                              }}
                              error={nameError}
                              helperText={nameError}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6 px-0 py-2">
                          <div className="prpfbd">
                            <TextField
                              style={{ width: "100%" }}
                              type="text"
                              id="standard-helperText"
                              label="Account Number"
                              variant="standard"
                              value={kycData?.accountNumber || ""}
                              onChange={(e) => {
                                setKycData((prevData) => ({
                                  ...prevData,
                                  accountNumber: e.target.value,
                                }));
                                validateAccountNumber(e.target.value);
                              }}
                              error={accountError}
                              helperText={accountError}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6 px-0 py-2">
                          <div className="prpfbd">
                            <FormControl
                              variant="standard"
                              sx={{ minWidth: 120, width: " 100% " }}
                              error={bankNameError}
                              helperText={bankNameError}
                            >
                              <InputLabel id="demo-simple-select-standard-label">
                                Bank Name
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={kycData?.bankName || ""}
                                onChange={(e) => {
                                  setKycData((prevData) => ({
                                    ...prevData,
                                    bankName: e.target.value,
                                  }));
                                  validateBankName(e.target.value);
                                }}
                                label="Bank Name"
                              >
                                {bankNames.map((bank) => (
                                  <MenuItem
                                    key={bank.BankCode}
                                    value={bank.BankName}
                                  >
                                    {bank.BankName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>

                        <div className="col-md-6 px-0 py-2">
                          <div className="prpfbd">
                            <TextField
                              style={{ width: "100%" }}
                              type="text"
                              id="standard-helperText"
                              label="IFSC Code"
                              variant="standard"
                              value={kycData?.ifscCode || ""}
                              onChange={(e) => {
                                setKycData((prevData) => ({
                                  ...prevData,
                                  ifscCode: e.target.value,
                                }));
                                validateIFSCCode(e.target.value);
                              }}
                              error={ifscError}
                              helperText={ifscError}
                              required
                            />
                          </div>
                        </div>

                        {plan_id == "SUPERSTARIND" && c_id == "star" && (
                          <>
                            <div className="col-md-6 px-0 py-2">
                              <div className="prpfbd">
                                <FormControl
                                  variant="standard"
                                  sx={{ width: "100%" }}
                                >
                                  <InputLabel
                                    id="demo-simple-select-standard-label"
                                    style={{ fontFamily: "12pt" }}
                                  >
                                    Account Type
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={kycData?.accountType || ""}
                                    onChange={(e) => {
                                      validateAccountType(e.target.value);
                                      setKycData((prevData) => ({
                                        ...prevData,
                                        accountType: e.target.value,
                                      }));
                                    }}
                                  >
                                    {accountType.map((data) => (
                                      <MenuItem
                                        key={data.value}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                                <span style={{ color: "red", fontSize: "9pt" }}>
                                  {accountTypeErr && (
                                    <p className="error-message red-text">
                                      {accountTypeErr}
                                    </p>
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-6 px-0 py-2">
                              <div className="prpfbd">
                                <TextField
                                  style={{ width: "100%" }}
                                  type="text"
                                  id="standard-helperText"
                                  label="Branch Name"
                                  variant="standard"
                                  value={kycData?.branchName || ""}
                                  onChange={(e) => {
                                    setKycData((prevData) => ({
                                      ...prevData,
                                      branchName: e.target.value,
                                    }));
                                    validateBranchName(e.target.value);
                                  }}
                                  error={branchError}
                                  helperText={branchError}
                                  required
                                />
                              </div>
                            </div>
                          </>
                        )}

                        <div
                          className="col-md-4 px-0 py-2"
                          style={{ marginTop: "-2px" }}
                        >
                          <div className="prpfbd"></div>
                        </div>
                      </div>
                    </>
                  ))}
                <div className="kyc-ref-div col-md-6">
                  <span className="kyc-ref-span">Referral No.</span>

                  <TextField
                    variant="standard"
                    className="kyc-ref-inp col-md-6"
                    fullWidth
                    value={referralNo}
                    onChange={handleReferralChange}
                    error={!!referralNoError}
                    helperText={referralNoError}
                  />

                  <div></div>
                </div>
              </div>
              <div></div>
            </div>

            <div className="col-lg-4">
              <Summary
                nextPage="summarypage"
                // callBack={callApi}
                planInfo={apiResponse}
                apiResponse={apiResponse}
                setApiResponse={setApiResponse}
                addonsArray={addonArr}
                setAddonArr={setAddonArr}
                setStopLoading={setStopLoading}
                kycData={kycData}
                validateKycForm={validateKycForm}
                addondataList={addonDataList}
                setAddonDataList={setAddonDataList}
                settingData={settingData}
                finalAddonList={finalAddonList}
                setFinalAddonList={setFinalAddonList}
                extData={extData}
                setExtData={setExtData}
              />
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default KYCfrom;
